import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import TextField, { TextFieldAdornmentText } from 'components/fields/TextField';
import FormError from 'components/common/FormError';

import {
  createVendor,
  updateVendor,
} from 'redux/modules/vendors';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

import objectDiff from 'utils/objectDiff';

const styles = () => ({
  grid: {
    marginTop: 10,
    '&:first-child': {
      marginTop: 0,
    },
  },
});

function onSubmit(values, dispatch, props) {
  if (props.ID) {
    if (props.pristine) {
      throw new SubmissionError({
        _error: 'Nothing to submit',
      });
    }
    const diffValues = objectDiff(values, props.initialValues);
    return new Promise((resolve, reject) => {
      dispatch(updateVendor({
        values: {
          ID: props.ID,
          ...diffValues,
        },
        resolve,
        reject,
      }));
    }).then(res => res,
      (err) => {
        throw new SubmissionError({ _error: err.error.indexOf('Unique check fail') !== -1
          ? 'Sorry, but such Vendor already exists' : err.error });
      });
  }

  return new Promise((resolve, reject) => {
    dispatch(createVendor({
      values,
      resolve,
      reject,
    }));
  }).then(res => res,
    (err) => {
      throw new SubmissionError({ _error: err.error.indexOf('Unique check fail') !== -1
        ? 'Sorry, but such Vendor already exists' : err.error });
    });
}

const VendorCreateEditForm = ({
  handleSubmit,
  className,
  error,
  classes,
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
  >
    {error &&
      <Grid
        className={classes.grid}
        container
        spacing={24}
      >
        <Grid
          item
          xs={12}
        >
          <FormError>
            {error}
          </FormError>
        </Grid>
      </Grid>
    }
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Vendor Name"
          name="Vendor Name"
          label="Vendor Name"
          component={TextField}
          validate={[validate.required]}
          errorPlacement="bottom"
          fullWidth
        />
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Email"
          name="Email"
          label="Email"
          component={TextField}
          validate={[validate.required, validate.email]}
          errorPlacement="bottom"
          fullWidth
        />
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={10}
      >
        <Field
          id="Mobile Phone"
          name="Mobile Phone"
          label="Mobile Phone"
          component={TextField}
          validate={[validate.required, validate.phone]}
          format={value => (value ? value.replace('+1 ', '') : '')}
          normalize={normalize.phone}
          maxLength="14"
          startAdornment={
            <InputAdornment position="start">
              <TextFieldAdornmentText>
                +1
              </TextFieldAdornmentText>
            </InputAdornment>
          }
          errorPlacement="top"
          fullWidth
        />
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Contact Person"
          name="Contact Person"
          label="Contact Person"
          component={TextField}
          validate={[validate.required]}
          errorPlacement="top"
          fullWidth
        />
      </Grid>
    </Grid>
  </form>
);

VendorCreateEditForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
  }).isRequired,
};

VendorCreateEditForm.defaultProps = {
  className: '',
  error: null,
};

export default reduxForm({
  form: 'vendorCreate',
  onSubmit,
})(withStyles(styles)(VendorCreateEditForm));



// WEBPACK FOOTER //
// ./src/components/vendor/VendorCreateEditDialog/VendorCreateEditForm.js